import {
  required,
  email,
  max,
  numeric,
  double,
  max_value
} from "vee-validate/dist/rules";
import { extend, setInteractionMode } from "vee-validate";
import i18n from "@/plugins/vueI18n";

setInteractionMode("eager");

const URL_REGEXP = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;

extend("numeric", {
  ...numeric,
  message: `{_field_} ${i18n.t('VeeValidate.Numeric')}`
});


extend("required", {
  ...required,
  message: (field) => {
    const translatedField = i18n.t(`VeeValidate.Fields.${field}`) || field
    return `${translatedField} ${i18n.t('VeeValidate.CanNotBeEmpty')}`;
  }
});

extend("max", {
  ...max,
  message: (field, values) => {
    const translatedField = i18n.t(`VeeValidate.Fields.${field}`) || field
    return `${translatedField} ${(i18n.t('VeeValidate.Max', { length: values.length }))}`;
  }
});

extend("max_value", {
  ...max_value,
  message: (field, values) => {
    const translatedField = i18n.t(`VeeValidate.Fields.${field}`) || field
    return `${translatedField} ${(i18n.t('VeeValidate.MaxValue', { max: values.max }))}`;
  }
});

extend("email", {
  ...email,
  message: `${i18n.t('VeeValidate.Email')}`
});

extend("url", {
  message: `${i18n.t('VeeValidate.Url')}`,
  validate: value => !!value && value.match(URL_REGEXP)
});

extend("double", {
  ...double,
  message: (field) => {
    const translatedField = i18n.t(`VeeValidate.Fields.${field}`) || field
    return `${translatedField} ${(i18n.t('VeeValidate.Double'))}}`;
  }
});
